import {  Injectable } from '@angular/core';
import { HttpErrorResponse, HttpInterceptor } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';

import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UserManagementService } from './Service/user-management.service';


import { SessionExpireComponent } from './Components/session-expire/session-expire.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  token: string;
  omitCalls = ['auth'];
  skipInterceptor = false;
  response: any;
  constructor(private router: Router,
    public _userService: UserManagementService, 
    private spinner: NgxSpinnerService, 
    public dialog: MatDialog
    ) { }

    intercept(
      request: HttpRequest<any>,
      next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(retry(1)
    ,catchError((error: HttpErrorResponse) => {
    
    if(error instanceof HttpErrorResponse){
      if ( error.status===408 ){
        const dialogRef = this.dialog.open(SessionExpireComponent,
        {
          width: '35%',
          height: '49%',
         });
        
        
        dialogRef.afterClosed().subscribe(result => {
        });
      }
    }
    return throwError(error.error);
    }))}
  }
  

 